import Alert from "react-bootstrap/Alert";
import { useTranslation } from "react-i18next";

function GlobalInfoBox(
  { globalInfoText }: { globalInfoText: string } = { globalInfoText: "" }
) {
  const { t, i18n } = useTranslation("common");
  const currentText = JSON.parse(globalInfoText)
    ? JSON.parse(globalInfoText)[i18n.language]
    : "";
  return (
    <>
      {currentText && (
        <Alert variant="warning" style={{ borderRadius: 0, marginBottom: 0 }}>
          <div style={{ maxWidth: "800px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>{t("alert.notice")}</p>
            <p style={{ marginBottom: 0 }}>{currentText}</p>
          </div>
        </Alert>
      )}
    </>
  );
}

export default GlobalInfoBox;
